// CRUD Operations
export const FETCH_GROUP_REQUEST = 'FETCH_GROUP_REQUEST';
export const FETCH_GROUP_FAILURE = 'FETCH_GROUP_FAILURE';
export const FETCH_GROUP_SUCCESS = 'FETCH_GROUP_SUCCESS';

export const CREATE_GROUP_REQUEST = 'CREATE_GROUP_REQUEST';
export const CREATE_GROUP_SUCCESS = 'CREATE_GROUP_SUCCESS';
export const CREATE_GROUP_FAILURE = 'CREATE_GROUP_FAILURE';

export const UPDATE_GROUP_REQUEST = 'UPDATE_GROUP_REQUEST';
export const UPDATE_GROUP_SUCCESS = 'UPDATE_GROUP_SUCCESS';
export const UPDATE_GROUP_FAILURE = 'UPDATE_GROUP_FAILURE';

// Select Operations
export const FETCH_GROUPS_SELECT_REQUEST = 'FETCH_GROUPS_SELECT_REQUEST';
export const FETCH_GROUPS_SELECT_FAILURE = 'FETCH_GROUPS_SELECT_FAILURE';
export const FETCH_GROUPS_SELECT_SUCCESS = 'FETCH_GROUPS_SELECT_SUCCESS';
export const FETCH_GROUP_SELECT_REQUEST = 'FETCH_GROUP_SELECT_REQUEST';
export const FETCH_GROUP_SELECT_FAILURE = 'FETCH_GROUP_SELECT_FAILURE';
export const FETCH_GROUP_SELECT_SUCCESS = 'FETCH_GROUP_SELECT_SUCCESS';
export const SELECT_GROUP = 'SELECT_GROUP';

// Extension Operations
export const FETCH_GROUPS_BY_EXTENSION_REQUEST = 'FETCH_GROUPS_BY_EXTENSION_REQUEST';
export const FETCH_GROUPS_BY_EXTENSION_FAILURE = 'FETCH_GROUPS_BY_EXTENSION_FAILURE';
export const FETCH_GROUPS_BY_EXTENSION_SUCCESS = 'FETCH_GROUPS_BY_EXTENSION_SUCCESS';

// Name Check
export const FIND_ONE_BY_NAME = 'GROUPS/FIND_ONE_BY_NAME/REQUEST';
export const FIND_ONE_BY_NAME_SUCCESS = 'GROUPS/FIND_ONE_BY_NAME/SUCCESS';
export const FIND_ONE_BY_NAME_FAILURE = 'GROUPS/FIND_ONE_BY_NAME/FAILURE';

// Currency
export const FETCH_GROUP_CURRENCY = 'GROUPS/CURRENCY/FETCH_REQUEST';

// Group Configuration
export const GROUP_CONFIG_IS_READY = 'GROUPS/CONFIG/IS_READY';
export const INITIALIZED_GROUP_TAB = 'GROUPS/CONFIG/INITIALIZED_TAB';

export const ASSIGN_TEMPLATE_FROM_GROUP_REQUEST = 'ASSIGN_TEMPLATE_FROM_GROUP_REQUEST';
export const ASSIGN_TEMPLATE_FROM_GROUP_SUCCESS = 'ASSIGN_TEMPLATE_FROM_GROUP_SUCCESS';
export const ASSIGN_TEMPLATE_FROM_GROUP_FAILURE = 'ASSIGN_TEMPLATE_FROM_GROUP_FAILURE';

export const ASSIGN_ENTITY_FROM_GROUP_REQUEST = 'ASSIGN_ENTITY_FROM_GROUP_REQUEST';
export const ASSIGN_ENTITY_FROM_GROUP_SUCCESS = 'ASSIGN_ENTITY_FROM_GROUP_SUCCESS';
export const ASSIGN_ENTITY_FROM_GROUP_FAILURE = 'ASSIGN_ENTITY_FROM_GROUP_FAILURE';

export const OPEN_ASSIGN_MODAL = 'OPEN_ASSIGN_MODAL';
export const HIDE_ASSIGN_MODAL = 'HIDE_ASSIGN_MODAL';

export const ASSIGNMENT_GROUP_TO_DEALERS_REQUEST = 'GROUPS/ASSIGNMENT_TO_DEALERS/REQUEST';
export const ASSIGNMENT_GROUP_TO_DEALERS_SUCCESS = 'GROUPS/ASSIGNMENT_TO_DEALERS/SUCCESS';

export const GROUP_MANAGEMENT_IS_READY = 'GROUP_MANAGEMENT_IS_READY';
